import Vue from 'vue';
import _ from 'lodash'
const ctx = "@@keepScrollPostion"
var savePos =function () {
  var vnode = this.vm;
  var liDom=this.el;
  var x = liDom.scrollTop
  if(!vnode.pos){
    vnode.pos={};
  }
  vnode.pos.x=x;
}
var doBind=function(){
    var liDom=this.el;
    liDom.removeEventListener("scroll",savePos);
    if(this.expression){
      liDom.addEventListener("scroll",savePos.bind(this));
    }

}

var doRecover=function(){
    var vnode = this.vm;
    if(this.expression){
      if(!_.isEmpty(vnode.pos)){
        if(vnode.pos){
          var liDom=this.el;
          liDom.scrollTop=vnode.pos.x;
        }
      }
    }

}
var isAttached = function(element) {
    var currentNode = element.parentNode;
    while (currentNode) {
        if (currentNode.tagName === 'HTML') {
            return true;
        }
        if (currentNode.nodeType === 11) {
            return false;
        }
        currentNode = currentNode.parentNode;
    }
    return false;
};
var getSelfRootVue=function(){

}
export default{
    bind(el,binding,vnode){
        var virgin = true;
        el[ctx]={
            el:el,
            vm:vnode.context,
            expression: binding.value
        }
        var execute=function () {
            doBind.call( el[ctx]);
        }
        var recover=function(arg,arg2){
            doRecover.call(el[ctx]);
        }
        if (el[ctx].vm._isMounted) {
            execute();
            return;
        }
        if(el[ctx].vm._isActivated){
            recover();
            return ;
        }
        el[ctx].vm.$on('hook:mounted', execute);
        el[ctx].vm.$on('hook:activated', recover);
        /**
        el[ctx].vm.$on('hook:updated',e=>{
          if(virgin){
            recover();
            virgin=false;
          }
        })
         */
    },
    unbind(){

    }

}
